<template>
  <div class="flex flex-col gap-1">
    <label class="font-semibold" :for="name"
      >{{ label }}<span v-if="required" class="text-red-600">*</span></label
    >
    <input
      class="rounded border px-5 py-3"
      :name="name"
      :required="required"
      :id="name"
      :type="type"
      :value="inputValue"
      :placeholder="placeholder"
      @input="handleChange($event.target.value)"
      @blur="handleBlur"
    />

    <p class="text-red-500" v-show="errorMessage && !meta.valid">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { toRef, computed } from 'vue';
import { useField } from 'vee-validate';
import * as yup from 'yup';
import { useI18n } from 'vue-i18n';

export default {
  props: {
    type: { type: String, default: 'number' },
    defaultSingleValue: { type: [String, Number, null], default: undefined }, // ✅ null разрешили
    name: { type: String, required: true },
    label: { type: String, required: true },
    successMessage: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    required: { type: Boolean, default: true },
    property: { type: Number, default: undefined },
  },

  setup(props) {
    const { t } = useI18n();
    const name = toRef(props, 'name');

    const rules = computed(() => {
      const base = yup
        .number()
        .transform((value, originalValue) => {
          // ✅ пустое поле -> null (и это будет валидно если required=false)
          if (originalValue === '' || originalValue === null || originalValue === undefined) {
            return null;
          }
          return value;
        })
        .nullable();

      return props.required ? base.required(t('warning.REQUIRED_MESSAGE')) : base.notRequired();
    });

    // ✅ initialValue: null/undefined -> '' чтобы input был чистым и без warning
    const initialValue =
      props.defaultSingleValue === null || props.defaultSingleValue === undefined
        ? ''
        : props.defaultSingleValue;

    const {
      meta,
      value: inputValue,
      errorMessage,
      validate,
      handleBlur,
      handleChange,
    } = useField(name, rules, { initialValue });

    return { inputValue, errorMessage, validate, meta, handleBlur, handleChange };
  },

  methods: {
    async validateField() {
      const validatedData = await this.validate();
      const v = this.inputValue;
      const num = v === '' ? null : Number(v);

      return {
        value: Number.isFinite(num) ? num : null,
        valid: validatedData.valid,
        mode: 'single',
        property: this.property,
      };
    },
  },
};
</script>

<style scoped></style>
